export const Coin = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" fill="#FFD700" stroke="#2b2b2b" strokeWidth="2" />
    <circle cx="12" cy="12" r="6.5" fill="#FFE561" stroke="#B8860B" strokeWidth="1.5" />
    <path
      d="M9.5 8.5h4a2 2 0 010 4H10.5v3h3"
      stroke="#7a5a00"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default Coin;
